import styled from 'styled-components';
import { achievements } from '../../data/constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding-top: 40px;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
`;

const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};

  @media screen and (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 32px;

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
  width: 100%;
`;

const Card = styled.div`
  width: 100%;
  max-width: 320px;
  background-color: rgba(17, 25, 40, 0.83);
  border: 1px solid rgba(255, 255, 255, 0.125);
  box-shadow: rgba(23, 92, 230, 0.15) 0 4px 24px;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Year = styled.div`
  color: ${({ theme }) => theme.primary};
  font-weight: 600;
  font-size: 14px;
`;

const CardTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
`;

const Org = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.text_secondary};
`;

const CardDesc = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.text_secondary};
`;

const Achievements = () => {
  return (
    <Container id="Achievements">
      <Wrapper>
        <Title>Achievements</Title>
        <Desc>Recognition from competitions, hackathons, and academic work.</Desc>
        <CardGrid>
          {achievements.map((item) => (
            <Card key={item.id}>
              <Year>{item.year}</Year>
              <CardTitle>{item.title}</CardTitle>
              <Org>{item.org}</Org>
              <CardDesc>{item.desc}</CardDesc>
            </Card>
          ))}
        </CardGrid>
      </Wrapper>
    </Container>
  );
};

export default Achievements;
